import React, { ReactElement } from "react";
import "./Footer.scss";

export const Footer: React.FC = (): ReactElement => {
    return <div className="login-footer">
        <h6>
            <a href="https://www.mountainstream.co/" target="_blank">Powered by Mountain Stream   Ⓒ  2012 - 2024</a>
        </h6>
    </div>
}